import { Link } from 'react-router-dom';
import { Seo } from '../../components/Seo';

export function NotFound() {
  return (
    <>
      <Seo title="Page not found" description="The requested page could not be found." noindex />
      <section className="page-hero">
        <div className="container">
          <div className="eyebrow">404</div>
          <h1>That route is not on today’s plan.</h1>
          <p className="lead">The page may have moved or the address may be incorrect.</p>
          <div className="actions">
            <Link className="button primary" to="/">
              Return home
            </Link>
            <Link className="button secondary" to="/downloads/desktop">
              Downloads
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
